<template>

  <div class="comment-add">
    <!-- 标题 -->
    <el-dialog :title="title" :visible.sync="dialogVisible" @close="dialogFormVisible" :close-on-click-modal="false"  :close-on-press-escape="false">
      <el-form size="small" :model="form" ref="form">

      <el-form-item label="选择用户"  :label-width="formLabelWidth" :rules="[{ required: true, message: ' ' }]" prop="user_id">
        <el-row>
          <el-button @click="addClick" icon="el-icon-plus">选择会员</el-button>
          <div v-if="form.user_id!=''" class="img">
            <img :src="user_info.avatarUrl" width="100" height="100" />
          </div>
          <div v-if="user_info">
            <p>用户ID：{{ user_info.user_id }}</p>
            <p>昵称：{{ user_info.nickName }}</p>
            <p>手机：{{ user_info.mobile }}</p>
          </div>
        </el-row>
      </el-form-item>

      <el-form-item label="授信额度" prop="price" :label-width="formLabelWidth">
        <el-input v-model="form.price" placeholder="请输入" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="已用额度" prop="used_price" :label-width="formLabelWidth">
        <el-input v-model="form.used_price" placeholder="请输入" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>
      <el-form-item label="剩余额度" prop="surplus_price" :label-width="formLabelWidth">
        <el-input v-model="form.surplus_price" placeholder="请输入" class="max-w460">
          <template slot="append">元</template>
        </el-input>
      </el-form-item>


      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible">取 消</el-button>
        <el-button  type="primary" @click="save" :loading="loading">确 定</el-button>
      </div>

    </el-dialog>

    <!--添加-->
    <GetUser :is_open="open_user" code=""  :otherParams="{is_investor:0}" @close="closeDialogFunc"></GetUser>

  </div>
</template>
 
<script>
  import CreditApi from '@/api/credit.js';
  import GetUser from '@/components/user/getInsUser.vue';
  export default {
    components: {
      GetUser
    },
    data() {
      return {
        // 类型
        type:'add',  // add:添加  edit:编辑 dateil:详情
        title:'添加',

        //需要提交的表单
        form: {
          user_id: '',
        },

        /*左边长度*/
        formLabelWidth: '120px',
        /*是否显示*/
        dialogVisible: false,//是否展示
        //加载
        loading: false,
        open_user: false,
        user_info: null,

      };
    },
    props: ['is_open', 'oneform'],//is_open 是否展示
    created() {
      //数据赋值
      this.type = this.oneform.type;

      //类型
      if(this.type == 'edit' || this.type == 'dateil'){
        if(this.type == 'edit' ){
          this.title = '编辑';
        }else{
          this.title = '详情';
        }
        //赋值
        this.form = this.oneform.model;
        if (!this.form.id) this.form.id = '';
      }

      //是否展示
      this.dialogVisible = this.is_open;
    },
    methods: {
      /*保存*/
      save() {
        let self = this;
        let params = self.form;
        self.$refs.form.validate((valid) => {
          if (valid) {
            self.loading = true;
            if(self.type == 'add'){
              CreditApi.addCredit(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }else if(self.type == 'edit'){

              CreditApi.editCredit(params).then(data => {
                self.loading = false;
                self.$message({
                  message: '添加成功',
                  type: 'success'
                });
                self.dialogFormVisible(true);
              }).catch(error => {
                self.loading = false;
              });
            }
          }
        })
      },

      /*关闭弹窗*/
      dialogFormVisible(e) {
        if (e) {
          this.$emit('closeDialog', {
            type: 'success',
            openDialog: false
          })
        } else {
          this.$emit('closeDialog', {
            type: 'error',
            openDialog: false
          })
        }
      },

      /*打开弹出层*/
      addClick() {
        this.open_user = true;
      },

      /*关闭获取用户弹窗*/
      closeDialogFunc(e) {
        if (e.type != 'error') {
          this.user_info = e.params[0];
          this.form.user_id = e.params[0].user_id;
        }
        this.open_user = false;
      },

    }
  };
</script>

<style>
 .img {
    margin-top: 10px;
    display: flex;
  }
  .img img {
    margin-right: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/views/user/credit/dialog/Add.vue